import { schema } from 'normalizr';

const city = new schema.Entity(
  'city',
  {},
  {
    processStrategy: ({ id, name }) => ({ id, name }),
  }
);

export default city;
